import { FC } from 'react'
import { SocialMediaProps } from './interfaces'

const Youtube: FC<SocialMediaProps> = ({
  width = 20,
  height = 20,
  color = 'white',
}) => {
  const fillColor = {
    white: '#FFFFFF',
    'grey-500': '#75787B',
    black: '#212721',
  }
  const DEFAULT_COLOR = fillColor.white

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.87903 9.75322L7.87817 4.06055L12.9143 6.9168L7.87903 9.75322ZM18.9324 3.07414C18.9324 3.07414 18.7503 1.67797 18.1915 1.06314C17.4828 0.25617 16.6883 0.252184 16.324 0.204936C13.7159 0 9.80356 0 9.80356 0H9.79545C9.79545 0 5.88321 0 3.27499 0.204936C2.91066 0.252184 2.11652 0.25617 1.40753 1.06314C0.848706 1.67797 0.666859 3.07414 0.666859 3.07414C0.666859 3.07414 0.480469 4.71369 0.480469 6.35326V7.89035C0.480469 9.52988 0.666859 11.1694 0.666859 11.1694C0.666859 11.1694 0.848706 12.5656 1.40753 13.1805C2.11652 13.9874 3.04784 13.9619 3.46262 14.0465C4.95371 14.2019 9.79952 14.25 9.79952 14.25C9.79952 14.25 13.7159 14.2436 16.324 14.0386C16.6883 13.9914 17.4828 13.9874 18.1915 13.1805C18.7503 12.5656 18.9324 11.1694 18.9324 11.1694C18.9324 11.1694 19.1186 9.52988 19.1186 7.89035V6.35326C19.1186 4.71369 18.9324 3.07414 18.9324 3.07414Z"
        fill={fillColor[color] || DEFAULT_COLOR}
      />
    </svg>
  )
}

export default Youtube
